import '@abraham/reflection';

import { getBoostTAE } from '@boost/widget-integration-tae/lib';
import { bootstrap, setupGlobalExtensions } from 'framework/core';

import { AppModule } from './modules/app/app.module';
import { warmupWorkers } from './workers/workers-provider';

async function main() {
  warmupWorkers();
  setupGlobalExtensions();

  const TAEApp = getBoostTAE();

  TAEApp.onReady(async () => {
    // Wait for customized script to be loaded
    try {
      await (TAEApp.getModuleByName('AssetFilesLoader') as any).assetLoadingPromise(
        'customizedScript'
      );
    } catch (error) {
      TAEApp.logger.error('Failed to load customized script', error);
    }

    await window.boostWidgetIntegration.onBeforeAppBootstrap?.();
    const app = await bootstrap(AppModule);

    Object.assign(window.boostWidgetIntegration, {
      App: app,
    });
  });
}

main();
